import React from "react";

import { Form, Formik } from "formik";

import { Typography, Button } from "clearsense-ui/components";
import { Select } from "clearsense-ui/components/formik";

import {
  EXISTING_SOURCE_INITIAL_VALUES,
  EXISTING_SOURCE_VALIDATION_SCHEMA,
} from "../../constants";

const ExistingSource = ({
  sources,
  catalogLoading,
  isStreamPresent,
  handleSourceSubmit,
}) => (
  <Formik
    initialValues={EXISTING_SOURCE_INITIAL_VALUES}
    validationSchema={EXISTING_SOURCE_VALIDATION_SCHEMA}
    onSubmit={handleSourceSubmit}
  >
    {({ dirty }) => (
      <Form className="space-y-4">
        <Typography style="h4" className="mt-6 border-b-2">
          Choose Source
        </Typography>
        <Select
          label="Source"
          required
          name="existingSource"
          placeholder="Select a source"
          className="w-3/4 mt-4"
          options={sources}
          isDisabled={isStreamPresent}
          data-cy="existing-source-select"
        />
        <Button
          label="Use existing source"
          type="submit"
          loading={catalogLoading}
          disabled={isStreamPresent || !dirty}
          data-cy="existing-source-submit-button"
        />
      </Form>
    )}
  </Formik>
);

export default ExistingSource;
